var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWeezticket = function SvgLogoWeezticket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoWeezticket_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.167 0H5.833A5.833 5.833 0 0 0 0 5.833v18.334A5.833 5.833 0 0 0 5.833 30h18.334A5.833 5.833 0 0 0 30 24.167V5.833A5.833 5.833 0 0 0 24.167 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0032FA",
    d: "M23.707 13.432h.835l.009-5.208h-6.638v1.738h4.896l-.002 1.842A3.482 3.482 0 0 0 20.2 15.17c0 1.617 1.11 2.98 2.608 3.366l.002 1.853h-4.896v1.738h6.638l-.01-5.22h-.866a1.74 1.74 0 0 1-1.738-1.779c.023-.948.821-1.696 1.77-1.696Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.995 16.479a.435.435 0 0 0-.435-.435H8.478a.435.435 0 0 0 0 .869h6.082a.436.436 0 0 0 .435-.434ZM8.478 17.782a.435.435 0 0 0 0 .87h3.91a.435.435 0 0 0 0-.87h-3.91ZM9.78 15.175a1.737 1.737 0 1 0 .001-3.474 1.737 1.737 0 0 0 0 3.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.48 19.955a.435.435 0 0 0-.435.435H6.303V9.962h10.743a.435.435 0 1 0 .87 0l-.002-.018v-1.72H5.434a.869.869 0 0 0-.868.869v12.165a.87.87 0 0 0 .869.869h12.478v-1.72l.002-.018a.435.435 0 0 0-.435-.434Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.48 18.217a.436.436 0 1 0 0 .869.435.435 0 1 0 0-.869ZM17.48 16.479a.434.434 0 1 0 0 .869.433.433 0 0 0 .423-.606.434.434 0 0 0-.423-.263ZM17.48 14.74a.436.436 0 1 0 0 .87.435.435 0 1 0 0-.87ZM17.48 13.003a.436.436 0 1 0 0 .868.433.433 0 0 0 .423-.606.433.433 0 0 0-.423-.262ZM17.48 11.265a.434.434 0 1 0 0 .869.433.433 0 0 0 .423-.606.434.434 0 0 0-.423-.263Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logoWeezticket_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgLogoWeezticket;